module.exports = __webpack_public_path__ + "img/product_hygl.f93eb516.png";